/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import { Input, Text } from '@chakra-ui/react';
import { UserTextComponent } from '@karya/core';
import { ChangeEventHandler } from 'react';
import { ParsedParams } from '@karya/generic-task-react';
import { ComponentRendererProps } from '../ComponentRenderer';

export function UserTextRenderer(props: ComponentRendererProps) {
  const typedParams = props.node.params as ParsedParams<UserTextComponent>;
  const component = props.node.component as UserTextComponent;

  const handleChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    if (!props.isCurrent) {
      return;
    }

    props.writeOutput(component.text, e.target.value);
  };

  if (props.isCurrent) {
    return (
      <Input
        variant="unstyled"
        padding="0"
        value={typedParams.text ?? ''}
        onChange={handleChange}
        width="100%"
        maxWidth="100%"
      />
    );
  }

  return (
    <Text fontSize="sm" width="100%">
      {typedParams.text}
    </Text>
  );
}
